import Axios from "axios";
import store from "../store";

Axios.defaults.withCredentials = true;

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URI + "/v1/"
});

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

if (urlParams.has("tk")) {
  const token = urlParams.get("tk");
  store.commit("LOGIN", token);
}

axios.interceptors.request.use(
  (config) => {
    if (store.state.token) {
      config.headers.Authorization = `Bearer ${store.state.token}`;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// Handle errors and responses gracefully.
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          //store.commit('LOGOUT');
          break;
        case 500:
          console.log(error.response.statusText);
          break;
      }
    }

    return Promise.reject(error.response.data);
  }
);

export default axios;
